module.exports = __webpack_public_path__ + "img/reading-guy@2x.e106466b.png";